<template>
  <div>
    <h1>{{ $t("delegationTask.title") }}</h1>
    <delegation-info-menu />
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field v-model="search" append-icon="search" :label="$t('global.search')" single-line hide-details />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="delegationTask"
      :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
      :search="search"
      hide-default-footer
    >
      <template #item="props">
        <tr>
          <td class="text-left">
            {{ props.item.list_order }}
          </td>
          <td class="text-left">
            {{ getName(props.item) }}
          </td>
          <td class="text-left">
            <span v-if="props.item.is_comment_required === 1">{{ $t("global.yes") }}</span>
            <span v-if="props.item.is_comment_required === 0">{{ $t("global.no") }}</span>
          </td>
          <td class="text-left">
            <span v-if="props.item.is_enabled === 1">{{ $t("global.yes") }}</span>
            <span v-if="props.item.is_enabled === 0">{{ $t("global.no") }}</span>
          </td>
          <td class=" justify-center align-content-center px-0">
            <span v-if="props.item.used_in_delegations > 0"
              >{{ $t("delegationTask.taskEditAppliesNTimes", props.item.used_in_delegations, { count: props.item.used_in_delegations }) }} <br
            /></span>
            <span v-if="props.item.used_in_delegations === 0">{{ $t("delegationTask.taskZeroTimes") }}<br /></span>
            <span v-if="props.item.is_system_value > 0">{{ $t("delegationTask.systemItem") }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DelegationInfoMenu from "../../components/DelegationInfoMenu.vue";

export default {
  name: "DelegationInfoDelegationTaskView",
  components: { DelegationInfoMenu },
  data: () => ({
    delegationTask: [],
    search: ""
  }),
  created() {
    this.axios.get("delegation-task/list").then(response => {
      this.delegationTask = response.data;
    });
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("delegationTask.headers.ordinate"),
          value: "list_order",
          sortable: true
        },
        { text: this.$t("delegationTask.headers.name"), value: "name" },
        {
          text: this.$t("delegationTask.headers.isCommentRequired"),
          value: "is_comment_required",
          sortable: false
        },
        {
          text: this.$t("delegationTask.headers.isEnabled"),
          value: "is_enabled",
          sortable: false
        },
        { text: " ", value: "name_en", sortable: false }
      ];
    }
  },
  methods: {
    getName(item) {
      if (this.$i18n.locale === "pl") return item.name;
      if (item.name_en == null || item.name_en.length < 1) return item.name;
      return item.name_en;
    }
  }
};
</script>

<style scoped></style>
